import React, { useState, useEffect } from 'react';
import { DebounceInput } from 'react-debounce-input';
import {
  Nav,
  NavItem,
  NavLink,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useLazyQuery, useMutation, useQuery } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import PropTypes from 'prop-types';
import ReactImageFallback from 'react-image-fallback';
import classnames from 'classnames';
import {
  LOGO_LARGE_WHITE, FALLBACK_ICON, getLocalUserData, staticConstants, handleGraphqlError, INVITATION_STATUS,
  routeConstants, history, OFFER_TABS, ARTIST_OFFER_LIST_STATUS, NUMERIC_VALUE,
}
  from '../../../utils';
import SettingsContainer from '../settings/SettingsContainer';
import Sidebar from '../../admin/sidebar/Sidebar';
import {
  GET_USER_DATA_QUERY, GET_ALL_ARTIST_QUERY, GET_ACTIVE_ARTIST, GET_USER_GIGS,
} from '../../../graphql-client/queries';
import { UPDATE_INVITATION } from '../../../graphql-client/mutations';
import Loading from '../loadingOverlay/Loading';
import OfferBoard from './OfferBoard';
import { askForPermissioToReceiveNotifications, showMessage } from '../../../config/firebase';
import { useChatMessageInitializer } from '../../../utils/chatMessageInitializer';

function renderOfferBoard({
  toggleTabOpen, tabOpen, activeTab, toggle, dropdownOpen, toggleDropdown, gigsDropdownOpen, toggleGigsDropdown,
  setOfferFilter, offerFilter, setSearchText, publicHeaderNotification, privateHeaderNotification, myOfferHeaderNotification,
  passedHeaderNotification, affiliateHeaderNotification, isTradeout, isLivestream, isStandard, setIsTradeout, setIsLivestream, setIsStandard,
  isPrivate, isAffiliate, setIsPrivate, setIsAffiliate,
}) {
  return (
    <>
      <div className="dashboard-after-head-tabs">
        <div className="dashboard-after-head-filter">
          <div className={`search ${activeTab === OFFER_TABS.PRIVATE_OFFERS ? 'pr-0' : ''}`}>
            <span className="search-icon" />
            <DebounceInput
              minLength={NUMERIC_VALUE.TWO}
              type="search"
              placeholder="Search by Gig name or Brand…"
              debounceTimeout={NUMERIC_VALUE.THREE_HUNDRED}
              onChange={(e) => { setSearchText(e.target.value); }}
            />
          </div>
        </div>
        <Nav tabs>
          <span
            onClick={toggleTabOpen}
            className={`tab-toggle ${tabOpen ? 'open' : 'close'}`}
          />
          <NavItem>
            <NavLink
              className={
                classnames({
                  active: activeTab === OFFER_TABS.ALL_OFFERS,
                  notify: publicHeaderNotification,
                })
              }
              onClick={() => { toggle(OFFER_TABS.ALL_OFFERS); }}
            >
              public gigs
            </NavLink>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle caret className="dropdown-head-button" />
              <DropdownMenu className="filter-dropdown">
                <DropdownItem header>Filter by</DropdownItem>
                <DropdownItem
                  className={classnames({ active: offerFilter === ARTIST_OFFER_LIST_STATUS.OFFER_BOARD })}
                  onClick={() => { setOfferFilter(ARTIST_OFFER_LIST_STATUS.OFFER_BOARD); }}
                >
                  All opportunity
                </DropdownItem>
                <DropdownItem
                  className={classnames({ active: offerFilter === ARTIST_OFFER_LIST_STATUS.OFFER_BOARD_REQUESTED })}
                  onClick={() => setOfferFilter(ARTIST_OFFER_LIST_STATUS.OFFER_BOARD_REQUESTED)}
                >
                  Opportunities i’ve applied on
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === OFFER_TABS.PRIVATE_OFFERS,
                notify: privateHeaderNotification,
              })}
              onClick={() => { toggle(OFFER_TABS.PRIVATE_OFFERS); }}
            >
              private gigs
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === OFFER_TABS.AFFILIATE_OFFERS,
                notify: affiliateHeaderNotification,
              })}
              onClick={() => { toggle(OFFER_TABS.AFFILIATE_OFFERS); }}
            >
              affiliate gigs
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === OFFER_TABS.MY_OFFERS,
                notify: myOfferHeaderNotification,
              })}
              onClick={() => { toggle(OFFER_TABS.MY_OFFERS); }}
            >
              My Gigs
            </NavLink>
            <Dropdown isOpen={gigsDropdownOpen} toggle={toggleGigsDropdown}>
              <DropdownToggle caret className="dropdown-head-button" />
              <DropdownMenu right className="filter-dropdown">
                <DropdownItem header>Filter by</DropdownItem>
                <DropdownItem
                  className={classnames({ active: offerFilter === ARTIST_OFFER_LIST_STATUS.MY_OFFER })}
                  onClick={() => { setOfferFilter(ARTIST_OFFER_LIST_STATUS.MY_OFFER); }}
                >
                  Current Gigs
                </DropdownItem>
                <DropdownItem
                  className={classnames({ active: offerFilter === ARTIST_OFFER_LIST_STATUS.EXPIRED })}
                  onClick={() => { setOfferFilter(ARTIST_OFFER_LIST_STATUS.EXPIRED); }}
                >
                  Completed Gigs
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavItem>
        </Nav>
        {
         (activeTab === OFFER_TABS.ALL_OFFERS || activeTab === OFFER_TABS.MY_OFFERS)
        && (
        <div className="tab-button">
          {
            activeTab === OFFER_TABS.MY_OFFERS && (
              <>
                <div className="select-label-wrap">
                  <label className="button-checkbox" htmlFor="private">
                    <input
                      type="checkbox"
                      id="private"
                      name="isPrivate"
                      checked={isPrivate}
                      onChange={(e) => setIsPrivate(e.target.checked)}
                    />
                    <span>Private</span>
                  </label>
                </div>
                <div className="select-label-wrap">
                  <label className="button-checkbox" htmlFor="affiliate">
                    <input
                      type="checkbox"
                      id="affiliate"
                      name="isAffiliate"
                      checked={isAffiliate}
                      onChange={(e) => setIsAffiliate(e.target.checked)}
                    />
                    <span>Affiliate</span>
                  </label>
                </div>
              </>
            )
          }
          <div className="select-label-wrap">
            <label className="button-checkbox" htmlFor="standard">
              <input
                type="checkbox"
                id="standard"
                name="isStandard"
                checked={isStandard}
                onChange={(e) => setIsStandard(e.target.checked)}
              />
              <span>Standard</span>
            </label>
          </div>
          <div className="select-label-wrap">
            <label className="button-checkbox" htmlFor="tradeout">
              <input
                type="checkbox"
                id="tradeout"
                name="isTradeout"
                checked={isTradeout}
                onChange={(e) => setIsTradeout(e.target.checked)}
              />
              <span>Trade-out</span>
            </label>
          </div>
          <div className="select-label-wrap">
            <label className="button-checkbox" htmlFor="livestream">
              <input
                type="checkbox"
                id="livestream"
                name="isLivestream"
                checked={isLivestream}
                onChange={(e) => setIsLivestream(e.target.checked)}
              />
              <span>Livestream</span>
            </label>
          </div>
        </div>
        )
        }
        <div className={`nav-tabs-sm ${tabOpen ? 'open' : 'close'}`}>
          <h2>Select Type</h2>
          <span
            onClick={() => { toggle(OFFER_TABS.ALL_OFFERS); }}
            className={classnames({ active: activeTab === OFFER_TABS.ALL_OFFERS })}
          >
            Public gigs
          </span>
          <span
            className={classnames({
              active: activeTab === OFFER_TABS.PRIVATE_OFFERS,
            })}
            onClick={() => { toggle(OFFER_TABS.PRIVATE_OFFERS); }}
          >
            Private gigs
          </span>
          <span
            className={classnames({
              active: activeTab === OFFER_TABS.AFFILIATE_OFFERS,
            })}
            onClick={() => { toggle(OFFER_TABS.AFFILIATE_OFFERS); }}
          >
            Affiliate gigs
          </span>
          <span
            onClick={() => { toggle(OFFER_TABS.MY_OFFERS); }}
            className={classnames({
              active: activeTab === OFFER_TABS.MY_OFFERS,
              notify: myOfferHeaderNotification,
            })}
          >
            My gigs
          </span>
        </div>
      </div>
    </>
  );
}
renderOfferBoard.propTypes = {
  toggleTabOpen: PropTypes.func.isRequired,
  tabOpen: PropTypes.bool.isRequired,
  activeTab: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  dropdownOpen: PropTypes.bool.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  gigsDropdownOpen: PropTypes.bool.isRequired,
  toggleGigsDropdown: PropTypes.func.isRequired,
  setOfferFilter: PropTypes.func.isRequired,
  offerFilter: PropTypes.func.isRequired,
  setSearchText: PropTypes.func.isRequired,
  publicHeaderNotification: PropTypes.bool.isRequired,
  privateHeaderNotification: PropTypes.bool.isRequired,
  myOfferHeaderNotification: PropTypes.bool.isRequired,
  passedHeaderNotification: PropTypes.bool.isRequired,
  affiliateHeaderNotification: PropTypes.bool.isRequired,
  isStandard: PropTypes.bool.isRequired,
  isTradeout: PropTypes.bool.isRequired,
  isLivestream: PropTypes.bool.isRequired,
  handleGigTypeFilter: PropTypes.func.isRequired,
};

function Dashboard(props) {
  useChatMessageInitializer();
  const { match, location: { hash, state } } = props;
  const isQuestionnaireSkipped = state?.isQuestionnaireSkipped;
  const userData = getLocalUserData();
  const [onScrollEffect, setOnScrollEffect] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [gigsDropdownOpen, setGigsDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tabOpen, setTabOpen] = useState(false);
  const [loginUser, setLoginUser] = useState();
  const [searchText, setSearchText] = useState();
  const [publicHeaderNotification, setPublicHeaderNotification] = useState(false);
  const [privateHeaderNotification, setPrivateHeaderNotification] = useState(false);
  const [myOfferHeaderNotification, setMyOfferHeaderNotification] = useState(false);
  const [passedHeaderNotification, setPassedHeaderNotification] = useState(false);
  const [affiliateHeaderNotification, setAffiliateHeaderNotification] = useState(false);
  const [isStandard, setIsStandard] = useState(false);
  const [isTradeout, setIsTradeout] = useState(false);
  const [isLivestream, setIsLivestream] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [isAffiliate, setIsAffiliate] = useState(false);
  const [gigTypeFilter, setGigTypeFilter] = useState([]);
  const [viewType, setViewType] = useState([]);

  const { data: gigsCountData } = useQuery(GET_USER_GIGS);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      history.replace(`#${tab}`);
      setActiveTab(tab);
      setOfferFilter(getDefaultOfferFilterForSelectedTab(tab));
    }
  };
  const { addToast } = useToasts();
  const [invitationToken, setInvitationtoken] = useState();
  const [offerFilter, setOfferFilter] = useState(null);
  const [activeArtistQuery, { loading, data: activeArtistData }] = useLazyQuery(GET_ACTIVE_ARTIST, { skip: userData.role !== staticConstants.ROLE.MANAGER });
  const [getUserDataQury, {
    error: getUserError, loading: getUserLoading, refetch: refetchUser, data: getUserData,
  }] = useLazyQuery(GET_USER_DATA_QUERY, {});
  const [getAllArtistQuery, {
    loading: artistQueryLoading, error: artistQueryError, data: allArtists, refetch: refetchAllArtists,
  }] = useLazyQuery(GET_ALL_ARTIST_QUERY, { skip: userData.role !== staticConstants.ROLE.MANAGER });

  const [updateInvitationMutation, { loading: updateInvitationLoading }] = useMutation(UPDATE_INVITATION,
    {
      variables: { token: invitationToken, status: INVITATION_STATUS.ACCEPTED },
      onCompleted: (data) => {
        if (data && !data.updateInvitation) {
          addToast('Invalid verification token', { appearance: 'error' });
        } else {
          if (userData.role === staticConstants.ROLE.MANAGER) {
            refetchAllArtists();
            addToast(data.updateInvitation.message, { appearance: 'success' });
          }
          refetchUser();
          history.push(routeConstants.DASHBOARD);
        }
      },
      onError: (err) => {
        addToast(handleGraphqlError(err), { appearance: 'error' });
        history.push(routeConstants.DASHBOARD);
      },
    });

  function checkNotification(offerData) {
    setPublicHeaderNotification(offerData.publicHeaderNotification);
    setPrivateHeaderNotification(offerData.privateHeaderNotification);
    setMyOfferHeaderNotification(offerData.myOfferHeaderNotification);
    setPassedHeaderNotification(offerData.passedHeaderNotification);
    setAffiliateHeaderNotification(offerData.affiliateHeaderNotification);
  }

  const handleScroll = () => {
    const headerTop = window.scrollY;
    headerTop >= 1 ? setOnScrollEffect(true) : setOnScrollEffect(false);
  };

  const getTab = (gigs) => {
    if (gigs) {
      if (gigs.publicCount !== NUMERIC_VALUE.ZERO) {
        return OFFER_TABS.ALL_OFFERS;
      }
      if (gigs.privateCount !== NUMERIC_VALUE.ZERO) {
        return OFFER_TABS.PRIVATE_OFFERS;
      }
      if (gigs.myGigs !== NUMERIC_VALUE.ZERO) {
        return OFFER_TABS.MY_OFFERS;
      }
      if (gigs.affiliateCount !== NUMERIC_VALUE.ZERO) {
        return OFFER_TABS.AFFILIATE_OFFERS;
      }
    }
    return OFFER_TABS.ALL_OFFERS;
  };

  const getDefaultOfferFilterForSelectedTab = (tab) => {
    switch (tab) {
      case OFFER_TABS.ALL_OFFERS:
        return ARTIST_OFFER_LIST_STATUS.OFFER_BOARD;
      case OFFER_TABS.PRIVATE_OFFERS:
        return null;
      case OFFER_TABS.MY_OFFERS:
        return ARTIST_OFFER_LIST_STATUS.MY_OFFER;
      default:
        return null;
    }
  };

  useEffect(() => {
    invitationToken && updateInvitationMutation();
  }, [invitationToken]);

  useEffect(() => {
    const gigType = [];
    const viewTypeFilter = [];
    if (isStandard) {
      gigType.push('standard');
    }
    if (isTradeout) {
      gigType.push('tradeout');
    }
    if (isLivestream) {
      gigType.push('livestream');
    }
    if (isPrivate) {
      viewTypeFilter.push('private');
    }
    if (isAffiliate) {
      viewTypeFilter.push('affiliate');
    }
    setGigTypeFilter(gigType);
    setViewType(viewTypeFilter);
  }, [isLivestream, isTradeout, isStandard, isPrivate, isAffiliate]);

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => window.history.go(1);
    document.addEventListener('scroll', handleScroll);
    const tabToBeSelected = getTab(gigsCountData?.gigsCount);
    userData && (() => {
      askForPermissioToReceiveNotifications();
      showMessage();
    })();
    userData.role === staticConstants.ROLE.MANAGER
      && (() => {
        activeArtistQuery();
        getAllArtistQuery();
      })();
    getUserDataQury();
    if (match && match.params && match.params.token) {
      setInvitationtoken(props.match.params.token);
    }
    if (hash) {
      const num = Number(hash.replace('#', ''));
      if (num && num > NUMERIC_VALUE.ZERO && num < NUMERIC_VALUE.SIX) {
        setActiveTab(String(num));
        setOfferFilter(getDefaultOfferFilterForSelectedTab(String(num)));
      } else {
        setActiveTab(OFFER_TABS.ALL_OFFERS);
        setOfferFilter(getDefaultOfferFilterForSelectedTab(OFFER_TABS.ALL_OFFERS));
      }
    } else {
      setActiveTab(tabToBeSelected);
      setOfferFilter(getDefaultOfferFilterForSelectedTab(tabToBeSelected));
    }
    return () => document.removeEventListener('scroll', handleScroll);
  }, [gigsCountData]);

  useEffect(() => {
    getUserError && addToast(handleGraphqlError(getUserError), { appearance: 'error' });
    artistQueryError && addToast(handleGraphqlError(artistQueryError), { appearance: 'error' });
  },
  [getUserError, artistQueryError]);

  useEffect(() => {
    getUserData && setLoginUser(getUserData?.getUser?.data);
  }, [getUserData]);

  if (loading || artistQueryLoading || getUserLoading || updateInvitationLoading) {
    return <Loading active />;
  }

  const getActiveArtistName = () => {
    if (allArtists && allArtists.getAllArtist && activeArtistData) {
      const data = allArtists.getAllArtist.data.find((da) => da._id === activeArtistData.activeArtist._id);
      return data.name;
    }
    return null;
  };
  const getActiveArtistImage = () => {
    if (allArtists && allArtists.getAllArtist && activeArtistData) {
      const data = allArtists.getAllArtist.data.find((da) => da._id === activeArtistData.activeArtist._id);
      return data.artistImage;
    }
    return null;
  };

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const toggleGigsDropdown = () => setGigsDropdownOpen((prevState) => !prevState);
  const toggleTabOpen = () => setTabOpen(!tabOpen);
  const toggleSidebarOpen = () => setSidebarOpen(!sidebarOpen);
  const renderProfileImage = () => {
    const image = userData.role === staticConstants.ROLE.MANAGER ? getActiveArtistImage() : loginUser && loginUser.artistImage;
    return (
      <>
        <ReactImageFallback
          src={image}
          fallbackImage={FALLBACK_ICON}
          alt="profile"
          className="img-cover"
        />
      </>
    );
  };
  return (
    <>
      {(userData && userData.role === staticConstants.ROLE.SYSTEM_ADMIN) && <Sidebar />}
      <div className={`dashboard ${sidebarOpen ? 'sidebarOpen' : ''}`}>
        {/* put "tab-button-space" class when tradeout and livestream badges appear */}
        <span
          onClick={toggleSidebarOpen}
          className="icon icon-cross sidebar-close"
        />
        <div className={`dashboard-head-wrapper ${onScrollEffect ? 'fixed-header' : ''}`}>
          <div className="dashboard-head">
            <span
              onClick={toggleSidebarOpen}
              className="toggle-icon"
            />
            <div className="dashboard-head-logo">
              <img src={LOGO_LARGE_WHITE} alt="BYGmusic" />
            </div>
          </div>
        </div>
        <div className="dashboard-after-head">
          <div className="dashboard-after-head-container">
            <div className="dashboard-head-setting">
              <SettingsContainer skipInterestSelectionForm={userData.isQuestionnaireSkipped} isQuestionnaireSkipped={isQuestionnaireSkipped} match={match} />
            </div>
            <div className="dashboard-after-head-profile">
              <div className="user-profile-upload">
                <Label>
                  {renderProfileImage()}
                </Label>
                <h2 className="text-capitalize">
                  {userData.role === staticConstants.ROLE.MANAGER
                    ? getActiveArtistName()
                    : `${loginUser && loginUser.name}`}
                </h2>
                <p>
                  {(activeArtistData && activeArtistData.activeArtist.email) || userData.email}
                </p>
              </div>
            </div>
            {((userData.role === staticConstants.ROLE.ARTIST)
              || (userData.role === staticConstants.ROLE.MANAGER && activeArtistData))
              && renderOfferBoard({
                toggleTabOpen,
                tabOpen,
                activeTab,
                toggle,
                dropdownOpen,
                toggleDropdown,
                gigsDropdownOpen,
                toggleGigsDropdown,
                setOfferFilter,
                offerFilter,
                publicHeaderNotification,
                privateHeaderNotification,
                myOfferHeaderNotification,
                passedHeaderNotification,
                affiliateHeaderNotification,
                setSearchText,
                isStandard,
                isLivestream,
                isTradeout,
                setIsLivestream,
                setIsStandard,
                setIsTradeout,
                setIsPrivate,
                setIsAffiliate,
                isPrivate,
                isAffiliate,
              })}
          </div>
        </div>
        {activeTab && loginUser && (userData.role === staticConstants.ROLE.ARTIST
          || (userData.role === staticConstants.ROLE.MANAGER && activeArtistData))
          && (
            <OfferBoard
              searchText={searchText}
              activeTab={activeTab}
              artistId={(activeArtistData && activeArtistData.activeArtist._id) || (loginUser && loginUser._id)}
              filter={offerFilter}
              hasNotification={checkNotification}
              match={match}
              hash={hash}
              gigTypeFilter={gigTypeFilter}
              viewTypeFilter={viewType}
            />
          )}
      </div>
    </>
  );
}
Dashboard.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.object,
    hash: PropTypes.string,
  }),
  match: PropTypes.shape({ params: { token: PropTypes.string } }),
};
Dashboard.defaultProps = {
  location: null,
  match: null,
};

export default Dashboard;
